import(/* webpackMode: "eager" */ "/var/www/restroagent/src/app/(landing)/cookie/page.tsx");
